import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowRight,FiClock,FiUsers,FiStar,FiCalendar,FiMapPin,FiPhone,FiMessageSquare,FiGlobe,FiFacebook,FiYoutube}=FiIcons;

const FinalCTASection=()=> {
  return (
    <section className="py-20 relative">
      {/* Premium Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-indigo-900 to-purple-900">
        <div className="absolute top-20 left-10 w-72 h-72 bg-indigo-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-500/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
        >
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-light text-white mb-8 leading-tight">
            เสียงเพรียกสุดท้าย... <br />
            <span className="text-indigo-400">สำหรับผู้ที่พร้อม</span>
          </h2>

          <motion.p
            className="text-2xl md:text-3xl text-slate-200 font-light mb-8 max-w-4xl mx-auto leading-relaxed"
            initial={{opacity: 0,y: 20}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.8,delay: 0.2}}
            viewport={{once: true}}
          >
            โชคชะตาไม่ใช่สิ่งที่ต้องยอมรับ... <br />
            <span className="text-purple-400">แต่คือสิ่งที่ต้องเข้าใจและนำทาง</span>
          </motion.p>

          {/* Event Info */}
          <motion.div
            className="bg-gradient-to-r from-indigo-900/30 to-purple-900/30 rounded-3xl p-10 mb-12 border border-indigo-500/20 backdrop-blur-sm max-w-5xl mx-auto"
            initial={{opacity: 0,scale: 0.9}}
            whileInView={{opacity: 1,scale: 1}}
            transition={{duration: 0.8,delay: 0.4}}
            viewport={{once: true}}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-6">
              <div className="flex items-center justify-center space-x-4">
                <SafeIcon icon={FiCalendar} className="w-8 h-8 text-indigo-400" />
                <div className="text-left">
                  <div className="text-2xl font-light text-white">21-23 พ.ย. 2568</div>
                  <div className="text-indigo-200">09.00 - 17.00 น. ทุกวัน</div>
                </div>
              </div>
              <div className="flex items-center justify-center space-x-4">
                <SafeIcon icon={FiMapPin} className="w-8 h-8 text-purple-400" />
                <div className="text-left">
                  <div className="text-2xl font-light text-white">S Ratchada Leisure Hotel</div>
                  <div className="text-purple-200">ห้อง Galleria ชั้น 2</div>
                </div>
              </div>
            </div>
            
            <p className="text-xl md:text-2xl text-indigo-100 font-light leading-relaxed">
              นี่คือโอกาสเดียวที่ประตูแห่งศาสตร์นี้จะเปิดออก... โดย Bazi Master <br />
              <span className="text-yellow-400 font-medium">ที่นั่งมีจำกัดสำหรับผู้ที่ "ใช่" เท่านั้น</span>
            </p>
          </motion.div>

          {/* Pricing Alert */}
          <motion.div
            className="bg-gradient-to-r from-red-500/20 to-orange-500/20 rounded-2xl p-8 mb-12 border border-red-500/20 max-w-3xl mx-auto backdrop-blur-sm"
            initial={{opacity: 0,scale: 0.9}}
            whileInView={{opacity: 1,scale: 1}}
            transition={{duration: 0.6,delay: 0.6}}
            viewport={{once: true}}
            animate={{scale: [1,1.02,1]}}
            transition={{duration: 3,repeat: Infinity}}
          >
            <div className="text-center">
              <div className="text-3xl font-light text-white mb-2">ราคาพิเศษ ฿9,580</div>
              <div className="text-2xl font-light text-blue-300 mb-2">นักศึกษา ฿7,580</div>
              <div className="text-orange-200 font-light mb-4">
                (จากราคาปกติ ฿35,000)
              </div>
              <div className="flex items-center justify-center space-x-4">
                <SafeIcon icon={FiClock} className="w-6 h-6 text-orange-400" />
                <span className="text-xl font-medium text-white">ที่นั่งจำกัด! จองเลย</span>
                <SafeIcon icon={FiUsers} className="w-6 h-6 text-orange-400" />
              </div>
            </div>
          </motion.div>

          {/* Final CTA Button */}
          <motion.div
            initial={{opacity: 0,y: 30}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.8,delay: 0.8}}
            viewport={{once: true}}
          >
            <motion.a
              href="https://www.fengshuix.com/event-details/the-bazi-blueprint"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-indigo-500 to-purple-500 text-white px-16 py-8 rounded-full text-2xl md:text-3xl font-light shadow-2xl hover:shadow-indigo-500/25 transition-all duration-300 inline-flex items-center space-x-4 mb-12"
              whileHover={{scale: 1.05,y: -5}}
              whileTap={{scale: 0.95}}
            >
              <span>จองที่นั่งของฉัน ฿9,580</span>
              <SafeIcon icon={FiArrowRight} className="w-8 h-8" />
            </motion.a>
          </motion.div>

          {/* Contact Information */}
          <motion.div
            className="bg-gradient-to-r from-slate-800/50 to-slate-700/50 rounded-3xl p-10 mb-16 border border-slate-600/30 backdrop-blur-sm max-w-4xl mx-auto"
            initial={{opacity: 0,y: 30}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.8,delay: 1}}
            viewport={{once: true}}
          >
            <h3 className="text-2xl font-light text-white mb-8 text-center">ช่องทางติดต่อและสอบถาม</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <motion.div
                className="flex items-center space-x-3 bg-white/5 rounded-2xl p-4"
                whileHover={{scale: 1.05}}
              >
                <SafeIcon icon={FiPhone} className="w-6 h-6 text-green-400" />
                <div>
                  <div className="text-white font-medium">โทรสอบถาม</div>
                  <div className="text-slate-300 text-sm">098-850-5900</div>
                </div>
              </motion.div>

              <motion.div
                className="flex items-center space-x-3 bg-white/5 rounded-2xl p-4"
                whileHover={{scale: 1.05}}
              >
                <SafeIcon icon={FiMessageSquare} className="w-6 h-6 text-green-500" />
                <div>
                  <div className="text-white font-medium">LINE ID</div>
                  <div className="text-slate-300 text-sm">@fengshuix</div>
                </div>
              </motion.div>

              <motion.div
                className="flex items-center space-x-3 bg-white/5 rounded-2xl p-4"
                whileHover={{scale: 1.05}}
              >
                <SafeIcon icon={FiGlobe} className="w-6 h-6 text-blue-400" />
                <div>
                  <div className="text-white font-medium">Website</div>
                  <div className="text-slate-300 text-sm">www.fengshuix.com</div>
                </div>
              </motion.div>

              <motion.div
                className="flex items-center space-x-3 bg-white/5 rounded-2xl p-4"
                whileHover={{scale: 1.05}}
              >
                <SafeIcon icon={FiFacebook} className="w-6 h-6 text-blue-500" />
                <div>
                  <div className="text-white font-medium">Facebook</div>
                  <div className="text-slate-300 text-sm">facebook.com/fengshuix</div>
                </div>
              </motion.div>

              <motion.div
                className="flex items-center space-x-3 bg-white/5 rounded-2xl p-4"
                whileHover={{scale: 1.05}}
              >
                <SafeIcon icon={FiYoutube} className="w-6 h-6 text-red-500" />
                <div>
                  <div className="text-white font-medium">YouTube</div>
                  <div className="text-slate-300 text-sm">fengshuix</div>
                </div>
              </motion.div>
            </div>
          </motion.div>

          {/* Trust Signals */}
          <motion.div
            className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-20 max-w-4xl mx-auto"
            initial={{opacity: 0,y: 30}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.8,delay: 1.2}}
            viewport={{once: true}}
          >
            <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-8 border border-white/10">
              <div className="text-3xl font-light text-indigo-400 mb-2">500+</div>
              <div className="text-white/80 font-light">ผู้เรียนที่เปลี่ยนชีวิต</div>
            </div>
            <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-8 border border-white/10">
              <div className="text-3xl font-light text-purple-400 mb-2">24</div>
              <div className="text-white/80 font-light">ชั่วโมงแห่งปัญญา</div>
            </div>
            <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-8 border border-white/10">
              <div className="text-3xl font-light text-yellow-400 mb-2">∞</div>
              <div className="text-white/80 font-light">ผลลัพธ์ตลอดชีวิต</div>
            </div>
          </motion.div>
        </motion.div>
      </div>

      {/* Premium Footer */}
      <motion.footer
        className="mt-20 pt-12 border-t border-white/10 text-center"
        initial={{opacity: 0}}
        whileInView={{opacity: 1}}
        transition={{duration: 0.8,delay: 1.4}}
        viewport={{once: true}}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <div className="w-10 h-10 bg-gradient-to-r from-indigo-400 to-purple-400 rounded-xl flex items-center justify-center">
              <SafeIcon icon={FiStar} className="text-white text-lg" />
            </div>
            <span className="text-white font-light text-2xl">Bazi Blueprint</span>
          </div>
          <p className="text-slate-400 font-light">
            © 2024 อาจารย์รวิ อัญญากาญจน์ (fengshuiX) | ศาสตร์แห่งปาจื้อ (八字,Bazi) สำหรับยุคใหม่
          </p>
        </div>
      </motion.footer>
    </section>
  );
};

export default FinalCTASection;